import TabSample from "./TabSample";

const TABS = [
  { path: Def.TAB_SAMPLE, element: TabSample },
];

export default TABS;
